module.exports = __webpack_public_path__ + "img/category_citytrips.ebc382e.png";